import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {AnalogOutDescription} from "./analogoutDescription";
import {UrlBuilder} from "../url-builder/url.builder";

@Injectable({
  providedIn: 'root'
})
export class AnalogOutDescriptionDataservice {

  private uiUrl: string = "";
  private url: UrlBuilder;

  constructor(private http: HttpClient) {
    this.url = new UrlBuilder();
  }

  GetData(): Observable<AnalogOutDescription> {
    this.uiUrl = this.url.GetAnalogOutDescriptionUrl();
    console.log('FILE: ' + this.uiUrl);
    return this.http.get<AnalogOutDescription>(this.uiUrl);
  }



}

